// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"178":"79c4970f","318":"8c13823e","319":"cfa7ab88","874":"7a4dd135"}[chunkId] + ".js";
};